import { MemoizedSelector, createFeatureSelector, createSelector } from '@ngrx/store';
import { StoryFeatureState } from '../states';

export const selectStoryFeatureState: MemoizedSelector<object, StoryFeatureState> = createFeatureSelector<StoryFeatureState>('storyFeature');
